import CentricDispatcher from './CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';


const createSuccessHandler = function() {
    const actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            CentricDispatcher.dispatch({
                type: action,
                data: response.data
            });
        });
    };
};

const createErrorHandler = function() {
    const actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            CentricDispatcher.dispatch({
                type: action,
                data: response.message
            });
        });
    };
};

const createFormErrorHandler = function() {
    const actions = Array.from(arguments);
    actions.push(ActionTypes.FORM_SUBMIT_ERROR);
    return createErrorHandler(...actions);
};

export default {
    createSuccessHandler: createSuccessHandler,
    createErrorHandler:   createErrorHandler,
    createFormErrorHandler,
    _handleFormError:     createErrorHandler(ActionTypes.FORM_SUBMIT_ERROR),
    _handleException:     createErrorHandler(ActionTypes.API_EXCEPTION)
};
